import React, { useState, useEffect, useCallback, useRef } from "react";
import { Container, Modal, Row, Col, Card, Button, Form } from "react-bootstrap";
import PropertyDetailTimer from "@/components/bid/PropertyDetailTimer";
import { Spinner } from "react-bootstrap";

import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { getBidHistory, withdrawBidById, getAutoBidDetails } from "@/api/bids";
import { baseApi } from "@/api/apiConfig";
import {
  getBidOfferDetails,
  getCifDetails,
  getBidDetailsById,
  getBuyerFilterDetails,
  getSoldPropertiesDetails,
} from "@/api/bids";
import { store } from "@/store/store";
import Loader from "../../common/loader/Loader";
import { navigateToProperty } from "@/utils/propertyNavigation";

// import imageOnTheWay from "../../../../../public/assets/images/imageOnTheWay.webp";

//  import OfferDetailsModal from '../../MyOffers/OfferDetailModal/OfferDetailsModal';
const SoldProperties = ({
  bidsData,
  bidOfferDetailList,
  bidDetailsById,
  componentType,
  onOfferDetailsClick,

  cifDeatils,
  showHistory,
}) => {
  const [showDetails, setShowDetails] = useState(false);
  const [showBidHistory, setShowBidHistory] = useState(false);
  const [showAutoBid, setShowAutoBid] = useState(false);
  const [autoBidData, setAutoBidData] = useState();
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const [openConfirmOffer, setOpenConfirmOffer] = useState(false);
  const [selectedListingId, setSelectedListingId] = useState("");
  const [bidDetails, setBidDetails] = useState();
  const [bidHistory, setBidHistory] = useState();
  const [selectedBidId, setSelectedBidId] = useState();
  const [selectedPropAdrs, setSelectedPropAdrs] = useState();
  const [showWithdrawConfirmation, setShowWithdrawConfirmation] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [cifData, setCifData] = useState(cifDeatils);
  const [selectedBidAmount, setSelectedBidAmount] = useState();
  const [previousBidsBuyerList, setPreviousBidsBuyerList] = useState();
  const [loading, setLoading] = useState(true);
  const state = store.getState();

  const userEmail = state?.user?.user?.userEmailId;

  const userID = state?.user?.user?.realbidUserId;

  const [page, setPage] = useState(1);
  const [loadingFirstPage, setLoadingFirstPage] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [selectedEmail, setSelectedEmail] = useState('All');
  const [isFilterSelected, setIsFilterSelected] = useState();
  const loaderSoldProps = useRef(null);



  const OFFER_ACTION_MAPPING = {
    BUYER_ACCEPT: "Buyer Accepted",
    BUYER_COUNTER: "Buyer Countered",
    BUYER_EXPIRED: "Buyer Offer Lapsed",
    BUYER_HNB: "Buyer Highest & Best",
    BUYER_REJECT: "Buyer Rejected",
    BUYER_WITHDRAWAL: "Buyer Withdrawn",
    CREATED: "Initial Offer",
    CREATE_EXPIRED: "Offer Expired",
    FALLOUT: "Fallout",
    SELLER_ACCEPT: "Seller Accepted",
    SELLER_COUNTER: "Seller Countered",
    SELLER_EXPIRED: "Seller Offer Lapsed",
    SELLER_HNB: "Seller Highest & Best",
    SELLER_REJECT: "Seller Rejected",
    SELLER_RESPONSE_PENDING: "Pending",
    SELLER_WITHDRAW: "Seller Withdrawn",
  };
  const getFormatPrice = (amount) => {
    if (amount?.length === 0 || isNaN(amount)) {
      return "";
    }
    return amount?.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  };

  const fetchBidList = async (pageNum, emailOverride = selectedEmail) => {

    console.log('emailOverride ', emailOverride)

    setLoadingFirstPage(true);

    const bidOfferResponse = await getBidOfferDetails({
      filterSelected: isFilterSelected ? "Y" : 'N',


      buyerEmailId: emailOverride === 'All' ? null : emailOverride === 'Self' ? userEmail : emailOverride,
      listingType: "AUCN",
      propertyStatus: null,
      // filterSelected: "N",
      // buyerEmailId: null,
      propertyAddress: "",
      type: "PREVIOUS",
      pageNo: pageNum,
    });

    if (bidOfferResponse) {
      setLoadingFirstPage(false);

    }
    return bidOfferResponse?.bidOfferDetailList;
  };



  useEffect(() => {



    const loadItems = async () => {


      if (loadingFirstPage || !hasMore) return;

      setLoadingFirstPage(true);


      try {
        const newItems = await fetchBidList(page);


        if (newItems?.length > 0) {
          setData((prev) => [...prev, ...newItems]);
        }

        if (newItems?.length < 8 || newItems === null) {


          setHasMore(false);
        }
      } catch (error) {
        console.error('Error fetching items:', error);
      } finally {
        setLoadingFirstPage(false);
      }
    };

    loadItems();
  }, [page]);



  useEffect(() => {
    const loadBuyerList = async () => {
      const data = await getSoldPropertiesDetails();
      setPreviousBidsBuyerList(data?.buyerDetailsList);
      setLoading(false);

    };

    loadBuyerList();
  }, [showHistory]);

  const handleObserver = useCallback((entries) => {
    if (loadingFirstPage) return;

    const target = entries[0];

    if (target.isIntersecting && hasMore && !loadingFirstPage) {
      if (loadingFirstPage) return
      const pageNum = page + 1;
      setPage((prev) => prev + 1);
      //setPage(page + 1);
    }
  }, [hasMore, loadingFirstPage]);

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: '20px',
      threshold: 1.0
    };
    const observer = new IntersectionObserver(handleObserver, option);
    if (loaderSoldProps.current) observer.observe(loaderSoldProps.current);
    return () => observer.disconnect();
  }, [handleObserver]);


  const handleBuyerSelection = async (e) => {

    var email = e.target.value;

    setSelectedEmail(email);
    setIsFilterSelected('Y')

    resetPageNumber(email);

  }

  const resetPageNumber = async (email) => {

    console.log('email ', email)

    const pageNum = 1;
    setPage(pageNum);
    setHasMore(true);

    const newItems = await fetchBidList(pageNum, email);
    setData(newItems);

    if (newItems?.length < 8 && newItems === null) {
      setHasMore(false);
    }
  }




  // Function to format address based on component type
  const getAddressAndDetails = (item) => {
    if (componentType === "offers") {
      const address = item?.propertyDetail?.propertyAddress;
      const offerActivity = item?.activeOffer?.offerActivity;

      return {
        propertyId: item?.propertyDetail?.propertyId || "N/A",
        fullAddress: address
          ? `${address.streetNumber} ${address.streetName}, ${address.city}, ${address.state} ${address.zip}`
          : "N/A",
        // Map the offer action to its corresponding display value
        offerAction: OFFER_ACTION_MAPPING[offerActivity] || "N/A",
        offerAmount: item?.activeOffer?.offerAmount
          ? new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(item.activeOffer.offerAmount)
          : "N/A",
      };
    } else {
      const address = item.propertyDetails?.address;
      return {
        fullAddress: address
          ? `${address.streetNumber} ${address.streetName}, ${address.city}, ${address.state} ${address.zip}`
          : "N/A",
      };
    }
  };




  const transformData = (inputData) => {
    return (
      inputData?.map((item) => ({
        bidOfferId: item?.bidOfferSummary?.bidOfferId,
        imageUrl: item?.imageUrl,

        addressDetails: getAddressAndDetails(item),

        bidOfferActions: item?.bidOfferSummary?.bidOfferActions,
        buttonText: item?.bidOfferSummary?.bidOfferActions?.includes(
          "CONFIRM_NEGOTIATION"
        )
          ? `Confirm Offer for $${getFormatPrice(
            item?.listingDetails?.solicitationAmount
          )}`
          : item?.bidOfferSummary?.bidOfferActions?.includes("PLACE_BACKUP_BID")
            ? "Place Backup Bid"
            : item?.bidOfferSummary?.bidOfferActions?.includes("PLACE_BEST_BID")
              ? "Place Best Bid"
              : "Place New Bid",
        bidDetailsLink: `/bid-details/${item.listingDetails?.listingId}`,
        bidHistoryLink: `/bid-history/${item.listingDetails?.listingId}`,
        latestBidAmount: item?.bidOfferSummary?.latestOfferAmount,
        highestBidAmount: item?.listingDetails?.currentHighestPrice,
        bidStatus: item?.bidOfferSummary?.status,
        sellerResponse: item?.bidOfferSummary?.sellerResponse,
        bidStatusMessageData: item?.bidOfferSummary?.bidStatusMessageData,
        listingStatus: item?.listingDetails?.listingStatus,
        listingDetails: item?.listingDetails,
        autoBidAmount: item?.bidOfferSummary?.autoBidAmount,
        propCategory: item?.propertyDetails?.commonAttributes?.propCategory,
        propertyId: item?.propertyDetails?.propertyId,
        propertyStatus: item?.propertyDetails?.commonAttributes?.status,
      })) || []
    );
  };

  const getIconPath = (item) => {

    if (item?.listingDetails?.currentHighestBuyer === userID && item.listingDetails.listingStatusDetail === "SUCCESSFUL") {

      return "/assets/images/soldtome_icon.png"


    } else {
      if (item.listingDetails.listingStatusDetail === "SUCCESSFUL") {
        return "/assets/images/soldIcon.png"
      } else {
        return "/assets/images/pdp/property-notavailable.png"
      }


    }
  }

  const getImagePath = (item) => {


    console.log('userEmail ', userEmail);
    console.log('item?.buyerEmailId ', item);
    if (item?.listingDetails?.currentHighestBuyer === userID && item.listingDetails.listingStatusDetail === "SUCCESSFUL") {
      return "/assets/images/no-photo.jpg"
    } else {
      if (item.listingDetails.listingStatusDetail === "SUCCESSFUL") {
        return "/assets/images/sold-no-image.png"
      } else {
        return "/assets/images/no-photo.jpg"
      }


    }

  }

  // Transform data based on component type
  const transformedData = transformData(data);



  return (
    <>
      {
        loading ?
          <div className="text-center p-4 mt30">
            <div className="mt30 pt30" role="">
              <Loader />
            </div>
          </div> :
          previousBidsBuyerList?.length > 0 &&
          <Row className="pl30">
            <Col xs={1} md={1} >
              <p className="buyer-list">By Buyer</p>
            </Col>
            <Col xs={10} md={10} >
              <Form.Select
                className="w-20"
                // value={selectYesBackupBid}
                onChange={handleBuyerSelection}

              >
                <option value="All" className="dropDownOptions">All</option>
                <option value="Self" className="dropDownOptions">Self</option>

                {(
                  previousBidsBuyerList
                )?.map((item) => (
                  <option className="dropDownOptions" key={item?.buyerEmailId} value={item?.buyerEmailId}>
                    {item.buyerFirstName + " " + item.buyerLastName}
                  </option>
                ))}
              </Form.Select>
            </Col>



          </Row >
      }
      {
        (data === null || data?.length === 0 && !loading) &&
        <Row className="align-items-center mb-4 pt100">
          <Col xs={12} md={12}>
            <div className="text-center">
              No Records found for the filters applied.
            </div>
          </Col>
        </Row>

        
      }
      {
         ((data !== null || data?.length !== 0) && !loading) &&
         <div className="p-3 pt30" style={{ borderBottom: "1px solid #cccc" }}>
                {" "}
                <Row>
                  <Col xs={6} md={6}>
                    <p className="colHeading">Property Details</p>
                  </Col>
                 
                  <Col xs={6} md={6}>
                    <p className="colHeading pr30" style={{ textAlign: 'right' }}>Actions</p>
                  </Col>
                </Row>
              </div>
      }

   
      {transformedData.map((item, index) => (
        <Row key={index} className="align-items-center mb-4">
          <Col xs={0} md={2}>

            <Card>

              <div
                className="position-relative w-100"
                style={{ paddingBottom: "60%" }}
                onClick={() => navigateToProperty(`/property/${item?.propertyId}`, item?.propCategory, item?.propertyStatus)}
              >
                <img
                  src={item?.imageUrl || getImagePath(item)}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/assets/images/no-photo.jpg";
                  }}
                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover rounded"
                  style={{ cursor: "pointer" }}
                  alt="Property"
                />
              </div>
            </Card>
          </Col>
          <Col xs={12} md={7} className="d-flex align-items-start">
            <div className="">
              {componentType === "offers" ? (
                <>
                  <p className="fw-bold mb-2" style={{ fontSize: "12px" }}>
                    {item.addressDetails.propertyId}{" "}
                    {item.addressDetails.fullAddress}
                  </p>
                  <p
                    className="mb-2"
                    style={{ fontSize: "12px", color: "#666" }}
                  >
                    <span className="fw-semibold">Offer Action:</span>{" "}
                    {item.addressDetails.offerAction}
                  </p>
                  <p
                    className="mb-0 me-2"
                    style={{ fontSize: "12px", color: "#666" }}
                  >
                    <span className="fw-semibold">Offer Amount:</span>{" "}
                    {item.addressDetails.offerAmount}
                  </p>
                </>
              ) : (
                <>
                  <p className="propAddress p0 m0">
                    {item?.addressDetails?.fullAddress}
                  </p>
                  <p className="auctionPrice">
                    My Latest Bid: ${getFormatPrice(item?.latestBidAmount)}
                  </p>
                </>
              )}
            </div>
          </Col>

          <Col xs={12} md={3} className="d-flex flex-column align-items-end">
            <div className="mt-2 " style={{ textAlign: "right" }}>
              <img
                className="img-fluid mb20"
                style={{ height: 80, width: 100 }}
                src={getIconPath(item)}
                alt=""
              />
            </div>
          </Col>
          <hr />
        </Row>
      ))}

      <div ref={loaderSoldProps} style={{ height: '50px', textAlign: 'center' }}>

      </div>
    </>
  );
};


export default SoldProperties;
